import { SITE } from './nav';

export type RouteChangeHandler = (slug: string, hash: string) => void;

function normalizePath(pathname: string): string {
  let path = pathname.replace(/^\/+|\/+$/g, '');
  if (!path || path === 'index.html') {
    return SITE.homeSlug;
  }
  return path;
}

export function getSlugFromLocation(): string {
  return normalizePath(window.location.pathname);
}

export function getHashFromLocation(): string {
  return window.location.hash.replace(/^#/, '');
}

export function navigate(slug: string, options?: { replace?: boolean }): void {
  const url = `/${slug}`;
  if (options?.replace) {
    history.replaceState({ slug }, '', url);
  } else {
    history.pushState({ slug }, '', url);
  }
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function initRouter(onChange: RouteChangeHandler): () => void {
  const handle = () => {
    onChange(getSlugFromLocation(), getHashFromLocation());
  };

  window.addEventListener('popstate', handle);

  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement | null;
    const anchor = target?.closest('a');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('http') || href.startsWith('mailto:')) return;
    if (anchor.target === '_blank') return;

    if (href.startsWith('#')) {
      return;
    }

    if (href.startsWith('/')) {
      event.preventDefault();
      const [path, hash] = href.slice(1).split('#');
      const slug = path || SITE.homeSlug;
      navigate(slug);
      if (hash) {
        requestAnimationFrame(() => {
          document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
        });
      }
    }
  });

  handle();

  return () => window.removeEventListener('popstate', handle);
}
